module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("4")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('hr', {
    staticClass: "hrch"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Because he was traveling solo instead of with his unit, he flew back to Vietnam on a commercial flight, aboard a Pan Am jet that landed at Saigon’s Tan Son Nhat Airport on a hot evening with a steady rain. He crossed the tarmac with his gear in his arms, feeling the rain splash against his face and breathing in the unique blend of jet fuel, garbage, and night-blooming flowers that would always say Vietnam to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had left Vietnam as Private Clay, but when he returned, he was Corporal Lincoln Clay, assigned to Detachment A-101, C Company, 5th Special Forces Group. Instead of returning to his unit, he was sent to a Special Forces Operating Base—an SFOB—near the 17th Parallel, which was the line that had been drawn to divide North and South Vietnam. The Special Forces troops at the SFOB were an A Team—officially advisers, not combatants, under the command of a B Team headquarters situated in Danang. He hitched a ride there on a helicopter carrying two government bureaucrats from Washington who, Lincoln guessed from their manner, had enjoyed their few days in Saigon a bit too heartily, and a reporter from the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Times")]), _vm._v(" who ignored Lincoln in favor of badgering the hungover guys in suits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three days after landing in Saigon, he was on the ground at the Lang Vei Special Forces Camp in Quang Tri Province, seven kilometers down Route 9 from where the Marines were busy building a major base at Khe Sanh. The terrain was mountainous, and the blades of the helicopter that had brought him there whipped dense fog into a funnel as it ascended again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("The camp was a chaotic-seeming assemblage of thatched huts and concrete bunkers. The dominant feature was a two-story concrete tower that Lincoln would learn was the TOC, the Tactical Operations Center.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln stood there as a second lieutenant greeted the bureaucrats and led them toward the TOC. A sergeant did the same with the reporter. Finally, after several minutes alone, a corporal emerged from the fog.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You lost?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Corporal Clay.” He patted the pocket containing his orders, as if that would mean anything to the other soldier. “I’ve been assigned here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The corporal eyed him. He was a white guy who hadn’t shaved in a week or so and maybe hadn’t bathed, either. His shirt hung open, and a scar that Lincoln thought looked as though it had been made by a knife puckered the flesh of his sternum. “Sorry to hear that,” he said. “You can still run, and I’ll pretend I didn’t see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Run where? All the way back to Saigon?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All the way back to Fort Bragg, if you know what’s good for you. Lang Vei is the shithole of Vietnam.” The corporal pointed north, then west. “Go any farther north and you’re in North Vietnam. Laos is just two clicks over there. It’s been pretty quiet lately, but that could change any time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess I’m here to stay,” Lincoln said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other man shrugged. “I’ll show you the team house. Captain’s in the TOC, but he’s got guests so you can meet him later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I flew in with them. They were looking pretty green.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Saigon will do that to you. Lincoln, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right. Lincoln, like the president.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Stephens,” the man said. “Duncan, like the yo-yo.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the way to the team house, they passed more indigenous faces than American ones. Stephens explained that there were only twenty-four Special Forces soldiers at the camp, but the force included a whole company of Montagnard tribesmen and three South Vietnamese rifle companies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Twenty-three now, actually,” Stephens corrected himself. “Well, you make twenty-four, I guess. You’re replacing DuPage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What happened to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He threw a grenade.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The answer confused Lincoln. “He "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("threw")]), _vm._v(" it?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“It hit a tree and bounced back. Everybody scrambled, but he was too slow. Surprised that it came back at him, I think. Anyway, he was still standing there when it went off.”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s some shitty luck,” Lincoln said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bad luck for him, bad luck for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stephens shrugged again. “Everybody liked DuPage. You live long enough, maybe they’ll like you, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or maybe not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chance you take,” Stephens said. “Sure you don’t want to run?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll stay,” Lincoln replied. “I’ll take that chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There were a half dozen guys in the team house. A couple were smoking on their bunks, one reading a paperback book. Three others played cards around a table laden with ashtrays and soda cans and a few beer bottles. One sat on his bunk in his underwear, strumming an acoustic guitar and mumbling the words to some song Lincoln didn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln suppressed a smile when he saw the table. Where there were booze, smokes, and gambling, there was money to be made. He would just have to figure out what the supply lines were and take them over for himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everybody except the guitarist looked up when Lincoln trailed Stephens inside. Stephens pointed to an empty bunk, and Lincoln dropped his duffel onto it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s DuPage’s bunk,” the guitarist said. He hadn’t raised his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess it’s mine now,” Lincoln said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guitarist shook his head slowly. “No respect for the dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you want me to do, sleep on the floor?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or outside. It don’t make any difference to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m pretty sure DuPage won’t care.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t know him,” the soldier with the book said. He set it down on the bunk, pages down, spine up. “He was from Alabama. He didn’t much care for colored folks. Having one sleeping in his bunk—he might just come back to haunt you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not too worried about ghosts,” Lincoln said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This here’s Lincoln Clay,” Stephens said. “Lincoln, like the president.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guy with the book barked a laugh. “Anybody DuPage hated worse than colored people, it was Lincoln.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("“He sounds like a charming dude,” Lincoln said. “Too bad he’s gone; we’d probably be best friends.”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The men all laughed at that, except the guitarist, who picked a mournful-sounding dirge.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Captain Prato appeared not to have an ounce of fat on him. His skin was tanned and tight and seemed to cling directly to his musculature. The other soldiers Lincoln had met here were casual about their uniforms and their hair—it was hard to be otherwise when both were constantly coated with dust that thickened into mud when the men sweated in the oppressive heat between their too-irregular field showers—but Prato was crisp and military to the core and somehow clean and shaved. Ushered into his presence, after the civilians from D.C. had been picked up by some marines from Khe Sanh, Lincoln whipped off his beret, snapped off a salute, and stood at attention while Prato studied him. After several long seconds, the captain said, “At ease, soldier.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln spread his legs and clasped his hands behind his back, still clutching the beret.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Welcome to Lang Vei, Corporal,” Prato said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I read your file. I gather you’re . . . new . . . to Special Forces.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Abbreviated course, it said.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yessir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know which end of a gun to point at the enemy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yessir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s something, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I won’t let you down, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’d better not. There aren’t enough of us here for anyone to not pull his own weight. The Montagnards are brave, and they hate the communists. The South Vietnamese regulars, I’m not always so sure about. Sometimes I think they’d sell us out for a few bucks and a bottle of wine. Other times I think it’d only take the wine. But it’s their war, so we’ve got to let them stay and fight it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand, sir,” Lincoln said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you speak Vietnamese?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, sir. I mean, just a few words.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What can you do?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Lincoln considered for a moment. “Well, sir, I guess not much. All I know for sure is I’m pretty good at killin’ people.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Prato cracked a smile, which looked like it hurt. He took it back in a hurry. “Well, that’s a start, I guess,” he said. “You’re dismissed, soldier.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c16ef8f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 69
// module chunks = 0